import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { useTranslation } from '@lt/localization';
import { FLIGHTS_DIRECTIONS } from 'src/routes/Checkout/CheckoutRoutes/PackageCheckout/store/flights/constants';
import FlightType from '../FlightType';
import { FlightTypePropTypes } from '../../../proptypes/flights';

import styles from './flightTypeSidebar.module.css';

// Если тип перелёта и класс совпадают, совместить информацию о типе рейса
const FlightTypeSidebar = ({
  isDateChangable,
  to,
  back,
  isMobile,
  isFlightsTypeEqual,
}) => {
  const { t } = useTranslation();
  if (isMobile && !isFlightsTypeEqual) {
    return null;
  }

  return (
    <div className={styles.container}>
      {isFlightsTypeEqual ? (
        <>
          {isMobile ? '' : `${t('checkout.flight.sidebar')} – `}
          <FlightType
            showFlightClass={!isDateChangable}
            showPluralTitle
            type={to}
            showIcon={false}
            showDescription={false}
            showTooltip={!isMobile}
          />
        </>
      ) : (
        [to, back].map((direction, index) => (
          <Fragment key={FLIGHTS_DIRECTIONS[index]}>
            {`${FLIGHTS_DIRECTIONS[index]} – `}

            <FlightType
              showFlightClass
              type={direction}
              showIcon={false}
              showDescription={false}
              showTooltip={!isMobile}
            />
          </Fragment>
        ))
      )}
    </div>
  );
};

FlightTypeSidebar.propTypes = {
  to: FlightTypePropTypes.isRequired,
  back: FlightTypePropTypes.isRequired,
  isMobile: PropTypes.bool.isRequired,
  isFlightsTypeEqual: PropTypes.bool.isRequired,
};

export default FlightTypeSidebar;
